const _ = require('./enum');

const schemes = {
  [_._]: { id: _._, label: 'None' },
  [_.ALIA_CARD]: { id: _.ALIA_CARD, label: 'Alia card' },
  [_.AMEX]: { id: _.AMEX, label: 'Amex' },
  [_.ARGENCARD]: { id: _.ARGENCARD, label: 'Argencard' },
  [_.AURA]: { id: _.AURA, label: 'Aura' },
  [_.BANCNET]: { id: _.BANCNET, label: 'Bancnet' },
  [_.BANCOMAT]: { id: _.BANCOMAT, label: 'Bancomat' },
  [_.BANCONTACT]: { id: _.BANCONTACT, label: 'Bancontact' },
  [_.CABAL]: { id: _.CABAL, label: 'Cabal' },
  [_.CARDOBESA]: { id: _.CARDOBESA, label: 'Cardobesa' },
  [_.CB]: { id: _.CB, label: 'Cb' },
  [_.CENCOSUD]: { id: _.CENCOSUD, label: 'Cencosud' },
  [_.CIRRUS]: { id: _.CIRRUS, label: 'Cirrus' },
  [_.CMR_FALABELLA]: { id: _.CMR_FALABELLA, label: 'Cmr falabella' },
  [_.CORDIAL]: { id: _.CORDIAL, label: 'Cordial' },
  [_.CUP]: { id: _.CUP, label: 'Cup' },
  [_.DANKORT]: { id: _.DANKORT, label: 'Dankort' },
  [_.DINERS]: { id: _.DINERS, label: 'Diners' },
  [_.DISCOVER]: { id: _.DISCOVER, label: 'Discover' },
  [_.ELO]: { id: _.ELO, label: 'Elo' },
  [_.EPS]: { id: _.EPS, label: 'Eps' },
  [_.GIROCARD]: { id: _.GIROCARD, label: 'Girocard' },
  [_.HIPERCARD]: { id: _.HIPERCARD, label: 'Hipercard' },
  [_.INTERAC]: { id: _.INTERAC, label: 'Interac' },
  [_.JCB]: { id: _.JCB, label: 'Jcb' },
  [_.J_DEBIT]: { id: _.J_DEBIT, label: 'J debit' },
  [_.LIDER]: { id: _.LIDER, label: 'Lider' },
  [_.MAESTRO]: { id: _.MAESTRO, label: 'Maestro' },
  [_.MAGNA]: { id: _.MAGNA, label: 'Magna' },
  [_.MASTERCARD]: { id: _.MASTERCARD, label: 'Mastercard' },
  [_.MASTERPASS]: { id: _.MASTERPASS, label: 'Masterpass' },
  [_.MERCADO_LIVRE]: { id: _.MERCADO_LIVRE, label: 'Mercado livre' },
  [_.MIR]: { id: _.MIR, label: 'Mir' },
  [_.MY_DEBIT]: { id: _.MY_DEBIT, label: 'My debit' },
  [_.NARANJA]: { id: _.NARANJA, label: 'Naranja' },
  [_.NATIVA]: { id: _.NATIVA, label: 'Nativa' },
  [_.NETS]: { id: _.NETS, label: 'Nets' },
  [_.OCA_CARD]: { id: _.OCA_CARD, label: 'Oca card' },
  [_.PRESTO]: { id: _.PRESTO, label: 'Presto' },
  [_.RUPAY]: { id: _.RUPAY, label: 'Rupay' },
  [_.TARJETA_SHOPPING]: { id: _.TARJETA_SHOPPING, label: 'Tarjeta shopping' },
  [_.TROY]: { id: _.TROY, label: 'Troy' },
  [_.VISA]: { id: _.VISA, label: 'Visa' },
};

module.exports = schemes;
